import React from 'react';
import styled from 'styled-components';
import {Link} from 'react-router-dom';
import Color from 'constants/colors';
import {Spacer} from 'layout/util';

const TinyLinks = styled.div`
	font-size: 12px;
	line-height: 19px;
	margin-left: 2px;
	@media screen and (max-width: 767px) {
		font-size: 16px;
		line-height: 22px;
		text-align: center;
	}
`;

const OverviewButton = styled.span`
	display: inline-block;
	font-weight: bold;
	font-size: 14px;
	text-transform: uppercase;
	text-align: center;
	border: 3px solid ${Color('purple')};
	color: ${Color('purple')};
	border-radius: 3px;
	padding: 3px 9px;
	@media not all and (hover: none) {
		&:hover {
			background-color: ${Color('purple')};
			color: #fff;
			cursor: pointer;
		}
	}
`;

const StyledLink = styled(Link)`
	display: block;
	text-decoration: none;
	margin: 0;
`;

const Container = styled.div`
	font-family: ${props=>props.theme.fonts.h4};
	text-align: left;
	@media screen and (max-width: 767px) {
		display: flex;
		flex-direction: column;
		align-items: center;
		background: #eee;
		margin: 10px 0;
		padding: 20px 0;
	}
`;

const CandidateSideNav = (props) => {
	const { opponents, link, position } = props.data;
	const opponentLinks = opponents.map( (opponent, i) => (
		<StyledLink key={i} to={opponent.link}>{opponent.name}</StyledLink>
	));
	return(
		<Container>
			<Link to={link}><OverviewButton>See the race</OverviewButton></Link>
			<Spacer height={10} />
			<TinyLinks>
				Or jump to other candidates running for {position}. (ranked by poll results): 
				<Spacer height={5} />
				{opponentLinks}
	  	</TinyLinks>
		</Container>
	);
}

export default CandidateSideNav;


// WEBPACK FOOTER //
// ./src/pages/june-5/races/components/CandidateSideNav.js